const runtimeConfig = window.mofQuoteCalculatorConfig || {};

export const getQuoteCalculatorConfig = () => window.mofQuoteCalculatorConfig || runtimeConfig;

export const getApiBaseUrl = () => {
  const config = getQuoteCalculatorConfig();

  return config.apiBaseUrl || 'https://monera-operations.vercel.app/api/v2/';
};

export const getEmailQuoteUrl = () => {
  const config = getQuoteCalculatorConfig();

  return config.emailQuoteUrl || '';
};

export const getApplicationActionUrl = () => {
  const config = getQuoteCalculatorConfig();

  return config.applicationActionUrl || '';
};

export const getApplicationThankYouUrl = () => {
  const config = getQuoteCalculatorConfig();

  return config.applicationThankYouUrl || '';
};

export const getLoadingImageUrl = () => {
  const config = getQuoteCalculatorConfig();

  return config.loadingImageUrl || '';
};



// WEBPACK FOOTER //
// blocks/quote-calculator/app/config.js